module.exports = __webpack_public_path__ + "img/pañal.32af4b15.png";